// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"513":"eceddf3d0df3c0d2fe5d","610":"d49bdece1e2623db4be3"}[chunkId] + ".bundle.js";
};